<template>
  <v-dialog v-model="visible" max-width="500">
    <box title="  ورود از طریق اکتیو دایرکتوری">
      <template slot="top-action-view">
        <v-btn icon small dark @click="visible = false"
          >
          <v-icon small> mdi-close</v-icon>
        </v-btn>
      </template>
      <div class="pa-3">
        <v-text-field v-model="domainLoginName" label="نام کاربری دامنه" />
        <v-text-field v-model="password" label="رمز عبور(وبکارت)" />
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn color="primary" class="px-3" @click="checkDomainLoginName">
            {{ $t("login") }}</v-btn
          >
        </div>
      </div>
    </box>
  </v-dialog>
</template>

<script>
import EosToastType from "../../model/EosToastType";
import ResultType from '../../model/ResultType';
export default {
  data() {
    return {
      visible: false,
      domainLoginName: "",
      password: "",
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    checkLogin(username) {
      this.$store
        .dispatch("checkLogin", { username: username, password: this.password })
        .then((result) => {
          if (result.type === ResultType.success) {
            localStorage.setItem("domainLoginName", this.domainLoginName);
            this.$emit(
              "changeDomainLoginName",
              this.domainLoginName,
            );
            this.visible = false;
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "رمز عبور نادرست می باشد",
            });
          }
        });
    },
    checkDomainLoginName() {
      if (!this.domainLoginName || !this.password) {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: this.$t("empty-username-password-error"),
        });
        return;
      }

      this.$store
        .dispatch("lock/IsValidDomainLoginName", {
          params: { domainUser: this.domainLoginName, ischeck:true },
        })
        .then((result) => {
          if (result.response) {
            var username = result.response.perno;
            this.checkLogin(username);
          } else {
            localStorage.removeItem("domainLoginName");
            this.$EosToast.show({
              type: EosToastType.error,
              msg: "نام کاربری وارد شده وجود ندارد یا دسترسی اکتیو دایرکتوری برای آن تنظیم نشده است",
            });
          }
        });
    },
  },
};
</script>

<style>
</style>